import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useDispatch } from 'react-redux';
import ActionTypes from '~/constants/actionTypes';
import getGeoLocationApi from '~/services/common/getGeoLocationApi';

export default function useGeolocation(isLoggedIn: boolean): void {
  const dispatch = useDispatch();

  // Retrieve user's geolocation when their login status changes
  useSubsequentEffect(() => {
    const geoLocationApi = getGeoLocationApi();

    geoLocationApi.getGeoLocation().then(location => {
      dispatch({
        type: ActionTypes.setGeolocation,
        payload: location
      });
    });
  }, [dispatch, isLoggedIn]);
}
